const getGroupAdminPermissionOptions = ({ messages }) => ({
  'manage-users': messages.settingsPermissionManageUsers,
  'manage-courses': messages.settingsPermissionManageCourses,
  'view-analytics': messages.settingsPermissionViewAnalytics
});

export default getGroupAdminPermissionOptions;
